import React, { useEffect, useState } from "react";
import {
  length_Hundred,
  length_Ten,
  length_Three,
} from "../../Utils/validators";
import FormInputField from "../../Component/FormInputField";
import PageTitle from "../pageTitle";
import LabelField from "../../Component/labelField";
import SubmitButton from "../../Component/SubmitButton";
import { List } from "react-virtualized";
import { useDispatch } from "react-redux";
import {
  examSectionAdd,
  examSectionList,
  examSectionType,
  examSectionUpdate,
  getExamListNew,
} from "../../Action/courseAction";
import { showErrorSnackbar } from "../../Action/snackbarAction";
import Dropdown from "../../Component/dropdown";

function CreateExamSection() {
  const dispatch = useDispatch();
  const [exam, setExam] = useState("");
  const [subExam, setSubExam] = useState("");
  const [examList, setExamList] = useState([]);
  const [subExamList, setSubExamList] = useState([]);
  const [examStreamList, setExamStreamList] = useState([]);
  const [selectedExam, setSelectedExam] = useState("");
  useEffect(() => {
    dispatch(
      examSectionList((res) => {
        if (res) {
          setExamList(res);
        }
      })
    );
  }, []);
  const onChangeExam = (value) => {
    setExam(value);
    setSelectedExam(value);
    setSubExam("");
    setSubExamList([]);
    setExamStreamList([]);
    if (value) {
      dispatch(
        examSectionType(value?._id, (res) => {
          if (res.length > 0) {
            setExamStreamList(res);
          }
        })
      );
    }
  };

  const changeCheckBox = (event, index, type) => {
    let newArray = JSON.parse(JSON.stringify(examStreamList));
    if (type === "examStream") {
      if (event.target.checked) {
        newArray[index]["isSelected"] = true;
        setExamStreamList(newArray);
      } else {
        newArray[index]["isSelected"] = false;
        setExamStreamList(newArray);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const selectedStateList = examStreamList
      .filter((item) => item.isSelected)
      .map((item) => {
        return item?._id;
      });
    if (selectedStateList?.length === 0) {
      dispatch(showErrorSnackbar("Please add Exams"));
      return;
    }
    const postData = {
      name: exam?.name,
      examTypeId: selectedStateList,
    };
    dispatch(
      examSectionUpdate(exam?._id, postData, () => {
        setExam("");
        // setExamList([]);
        // setSubExamList([]);
        // setExamStreamList([]);
        setSelectedExam("");
        // examSectionList();
      })
    );
  };
  function renderRow({ index, key, style }) {
    return (
      <div key={key} style={style}>
        <div key={examStreamList[index]?._id} className="px-1">
          <div className="w-100">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex e-input align-items-center">
                <input
                  id={examStreamList[index]?._id}
                  className="form-check-input check cursor"
                  type="checkbox"
                  checked={examStreamList[index]?.isSelected}
                  onChange={(event) => {
                    changeCheckBox(event, index, "examStream");
                  }}
                />
                <label
                  className="ms-2 mt-1 form-check-label cursor"
                  for={examStreamList[index]?._id}
                >
                  {examStreamList[index]?.name}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const validations = () => {
    const selectedExam = examStreamList?.filter((item) => item?.isSelected);
    let isBlank = false;
    selectedExam?.map((item) => {
      if (item?.isSelected === "" || item?.name === "" || item?._id === "") {
        isBlank = true;
      }
    });
    return (
      exam === "" ||
      (subExamList.length > 0 && subExam === "") ||
      isBlank === true
    );
  };

  return (
    <div>
      <div className="contentBox">
        <PageTitle name={"EXAM CAREGORY"} />
        <div className="formDiv contentScrollbar">
          <form className="col-auto formWidth" onSubmit={handleSubmit}>
            <div className="d-flex col-6 align-items-center">
              <LabelField labelName={"Exam Name"} isRequired={true} />
              <div className="w-100">
                <Dropdown
                  labelName="Select Exam Name"
                  setInputText={(value) => onChangeExam(value)}
                  options={examList}
                  value={selectedExam}
                />
              </div>
            </div>
            {exam !== "" && examStreamList?.length > 0 ? (
              <div className="d-flex">
                <LabelField labelName={"Exam Stream List"} isRequired={true} />
                <div className="assign_container border rounded p-2">
                  <div className="d-flex justify-content-between fw-bold mb-3"></div>
                  <div className="input-border">
                    <List
                      height={350}
                      rowCount={examStreamList.length}
                      rowHeight={40}
                      rowRenderer={renderRow}
                      width={400}
                    />
                  </div>
                </div>
              </div>
            ) : null}
            <SubmitButton name="Save" validations={validations()} />
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateExamSection;
